import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.number.constructor";
import databus, { Origins } from '@ykz/ykz-http/core';
/* eslint-disable */
/* 疫情提示组件
 * <component-epidemic-tips type="1" id="123" z-index="1999" v-if=""></component-epidemic-tips>
 * type: 1.产品id，2酒景id，默认值2
 * id: 酒景或产品id，必传
 * z-index: 层级多少，默认1999，非必传
 */
export default {
  name: "epidemic_tips",
  data: function data() {
    return {
      showEpidemicTips: 0,
      ncpMessage: "",
      //疫情提示文案
      jumpLink: ""
    };
  },
  props: {
    type: {
      type: [String, Number],
      default: 2
    },
    id: {
      type: [String, Number]
    },
    zIndex: {
      type: [String, Number],
      default: 1999
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    window.componentCenter.epidemicTips = this;
    console.log("ycf组件初始化：epidemicTips");
    this.getIsShow();
  },
  methods: {
    getIsShow: function getIsShow() {
      var that = this;
      databus({
        url: "api/room/showSpecialMessageByNcp",
        type: "get",
        origin: Origins.API_GOOD,
        data: {
          type: this.type,
          id: this.id
        },
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            res.content = res.content || {};
            that.showEpidemicTips = res.content.isShow && res.content.ncpMessage ? 1 : 0;
            that.ncpMessage = res.content.ncpMessage;
            that.jumpLink = res.content.jumpLink;
          }
        }
      });
    },
    onClickTips: function onClickTips() {
      window.location.href = this.jumpLink;
    }
  }
};